import { ManageUser } from '@dealstack/frontend/admin/pages/Manage/User/ManageUser/ManageUser';
import { Route } from 'react-router-dom';
import { ManageInvestor } from '@dealstack/frontend/admin/pages/Manage/User/ManageInvestor/ManageInvestor';
import { ManageInvestorPersonalDetails } from '@dealstack/frontend/admin/pages/Manage/User/ManageInvestorPersonalDetails/ManageInvestorPersonalDetails';
import { ListUser } from '@dealstack/frontend/admin/pages/Manage/User/ListUser/ListUser';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry';

export enum MANAGE_USER_ROUTES {
	ADMIN = '/admin/:adminId',
	INVESTOR = '/investor/:investorId',
	USER = '/user/:userId',
	INVITATIONS_LIST = '/invitations-list',
	USER_ROLE = 'role/:userId',
	INVESTOR_PERSONAL_DETAILS = '/investor/personal-details/:userId',
}

export const ManageInvestors = () => {
	return (
		<div style={{ margin: '2rem' }}>
			<SentryRoutes>
				<Route path={`${MANAGE_USER_ROUTES.INVESTOR}`} element={<ManageInvestor />} />
				<Route path={MANAGE_USER_ROUTES.USER} element={<ManageUser />} />
				<Route
					path={`${MANAGE_USER_ROUTES.INVESTOR_PERSONAL_DETAILS}`}
					element={<ManageInvestorPersonalDetails />}
				/>
				<Route path="*" element={<ListUser />} />
			</SentryRoutes>
		</div>
	);
};
